import { render, staticRenderFns } from "./personalRecord.vue?vue&type=template&id=8a32ff84&scoped=true&"
import script from "./personalRecord.vue?vue&type=script&lang=js&"
export * from "./personalRecord.vue?vue&type=script&lang=js&"
import style0 from "./personalRecord.vue?vue&type=style&index=0&id=8a32ff84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a32ff84",
  null
  
)

export default component.exports